"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AclCategory = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
let AclCategory = class AclCategory {
    constructor(id, name, description, createdBy, updatedBy, categoryKey, parent, applicationScope) {
        this.id = id;
        this.name = name;
        this.description = description;
        this.createdBy = createdBy;
        this.updatedBy = updatedBy;
        this.categoryKey = categoryKey;
        this.parent = parent;
        this.applicationScope = applicationScope;
    }
};
exports.AclCategory = AclCategory;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({ name: "id" }),
    tslib_1.__metadata("design:type", Number)
], AclCategory.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "name",
        type: "varchar",
        length: 50,
        unique: true,
        nullable: false,
    }),
    tslib_1.__metadata("design:type", String)
], AclCategory.prototype, "name", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "description", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], AclCategory.prototype, "description", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "parent", type: "varchar" }),
    tslib_1.__metadata("design:type", String)
], AclCategory.prototype, "parent", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "category_key", type: "varchar" }),
    tslib_1.__metadata("design:type", String)
], AclCategory.prototype, "categoryKey", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "application_scope", type: "varchar" }),
    tslib_1.__metadata("design:type", String)
], AclCategory.prototype, "applicationScope", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({
        name: "created_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
        nullable: false,
    }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], AclCategory.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({
        name: "updated_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
        nullable: false,
    }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], AclCategory.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "varchar", length: 255, nullable: false }),
    tslib_1.__metadata("design:type", String)
], AclCategory.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "varchar", length: 255, nullable: false }),
    tslib_1.__metadata("design:type", String)
], AclCategory.prototype, "updatedBy", void 0);
exports.AclCategory = AclCategory = tslib_1.__decorate([
    (0, typeorm_1.Entity)("acl_categories"),
    tslib_1.__metadata("design:paramtypes", [Number, String, String, String, String, String, String, String])
], AclCategory);
